/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Ranked_SemanticInputs */

const en_search_ranked_semantic = /** @type {(inputs: Search_Ranked_SemanticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ranked by semantic relevance to your description.`)
};

const zh_hans1_search_ranked_semantic = /** @type {(inputs: Search_Ranked_SemanticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按与你描述的语义相关度排序。`)
};

const pt_br2_search_ranked_semantic = /** @type {(inputs: Search_Ranked_SemanticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenado pela relevância semântica para a sua descrição.`)
};

const es_search_ranked_semantic = /** @type {(inputs: Search_Ranked_SemanticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenados por relevancia semántica respecto a tu descripción.`)
};

const fr_search_ranked_semantic = /** @type {(inputs: Search_Ranked_SemanticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classés par pertinence sémantique par rapport à votre description.`)
};

const de_search_ranked_semantic = /** @type {(inputs: Search_Ranked_SemanticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach semantischer Relevanz zu deiner Beschreibung sortiert.`)
};

const ru_search_ranked_semantic = /** @type {(inputs: Search_Ranked_SemanticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отсортировано по смысловой близости к вашему описанию.`)
};

const it_search_ranked_semantic = /** @type {(inputs: Search_Ranked_SemanticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordinati per rilevanza semantica rispetto alla tua descrizione.`)
};

/**
* | output |
* | --- |
* | "Ranked by semantic relevance to your description." |
*
* @param {Search_Ranked_SemanticInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const search_ranked_semantic = /** @type {((inputs?: Search_Ranked_SemanticInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Ranked_SemanticInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_search_ranked_semantic(inputs)
	if (locale === "pt-BR") return pt_br2_search_ranked_semantic(inputs)
	if (locale === "es") return es_search_ranked_semantic(inputs)
	if (locale === "fr") return fr_search_ranked_semantic(inputs)
	if (locale === "de") return de_search_ranked_semantic(inputs)
	if (locale === "ru") return ru_search_ranked_semantic(inputs)
	if (locale === "it") return it_search_ranked_semantic(inputs)
	return en_search_ranked_semantic(inputs)
});